<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Islas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Lugar</li>
                  <li class="breadcrumb-item active">Islas</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-3 pt-2 pb-2">
                <h5 class="mb-0">Formulario {{ accion }} Islas</h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Geocercas"
                    data-toggle="tab"
                    href="#Geocercas"
                    v-if="form.id"
                    >Geocercas</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="codigo">Código Alterno</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="codigo"
                            v-model="form.codigo"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="nombre">Nombre</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="nombre"
                            v-model="form.nombre"
                            :class="
                              $v.form.nombre.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="sigla">Sigla</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="sigla"
                            v-model="form.sigla"
                            :class="
                              $v.form.sigla.$invalid ? 'is-invalid' : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="ciudad">Ciudad</label>
                          <v-select
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            v-model="ciudad"
                            label="nombre"
                            :options="listasForms.ciudades"
                            placeholder="Ciudades"
                            @input="getSelectCiudades()"
                          ></v-select>
                        </div>
                      </div>
                      <div class="col-md-3" v-if="ciudad.id">
                        <div class="form-group">
                          <label for="ciudad">Departamento</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="departamento"
                            v-model="ciudad.departamento.descripcion"
                            readonly
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="bloque">Bloque</label>
                          <v-select
                            v-model="bloque"
                            class="form-control form-control-sm p-0"
                            :class="[
                              $store.getters.getDarkMode ? 'dark-vselect' : '',
                              $v.form.bloque_id.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                            ]"
                            label="nombre"
                            :options="listasForms.bloques"
                            placeholder="Bloques"
                            @input="getSelectBloques()"
                          ></v-select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="dirreccion">Dirección</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="dirreccion"
                            v-model="form.dirreccion"
                            :class="
                              $v.form.dirreccion.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="latitud">Latitud</label>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="latitud"
                            v-model="form.latitud"
                            :class="
                              $v.form.latitud.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="longitud">Longitud</label>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="longitud"
                            v-model="form.longitud"
                            :class="
                              $v.form.longitud.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="horas_limite_solicitud"
                            >Límite de Solicitud <sup>(horas)</sup></label
                          >
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="horas_limite_solicitud"
                            v-model="form.horas_limite_solicitud"
                            :class="
                              $v.form.horas_limite_solicitud.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="promedio_cargue"
                            >Promedio Cargue <sup>(vehículos)</sup></label
                          >
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="promedio_cargue"
                            v-model="form.promedio_cargue"
                            :class="
                              $v.form.promedio_cargue.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="activo">Activo</label>
                          <select
                            class="form-control form-control-sm"
                            v-model="form.activo"
                          >
                            <option value="">Seleccione...</option>
                            <option
                              v-for="activo in listasForms.activos"
                              :key="activo.numeracion"
                              :value="activo.numeracion"
                            >
                              {{ activo.descripcion }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="tipo_sitio">Venta / Comprado</label>
                          <select
                            class="form-control form-control-sm"
                            v-model="form.comercial_producto"
                          >
                            <option value="">Seleccione...</option>
                            <option
                              v-for="venta_comprado in listasForms.venta_comprado"
                              :key="venta_comprado.numeracion"
                              :value="venta_comprado.numeracion"
                            >
                              {{ venta_comprado.descripcion }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="tipo_sitio">Instalaciones</label>
                          <v-select
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            v-model="form.instalaciones"
                            label="descripcion"
                            :options="listasForms.instalaciones"
                            placeholder="Instalaciones"
                            :reduce="(instalacion) => instalacion.numeracion"
                            multiple
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="Geocercas" v-if="form.id">
                  <div class="card-body">
                    <SitioGeocerca v-if="form.id" />
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <button
                    class="btn bg-primary col-md-1"
                    v-show="!$v.form.$invalid"
                    @click="save()"
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, helpers } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import SitioGeocerca from "./SitioGeocerca.vue";
import Loading from "../../../../components/Loading";
const timeFormat = helpers.regex(
  "timeFormat",
  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/,
);

export default {
  name: "SitioForm",
  components: {
    vSelect,
    SitioGeocerca,
    Loading,
  },
  data() {
    return {
      cargando: false,
      form: {
        id: null,
        pais_id: 3,
        nombre: null,
        sigla: null,
        ciudad_id: null,
        bloque_id: null,
        dirreccion: null,
        latitud: null,
        longitud: null,
        instalaciones: [],
      },
      ciudad: {},
      bloque: {},
      accion: "",
      metodo: "",

      listasForms: {
        ciudades: [],
        tipo_sitios: [],
        activos: [],
        venta_comprado: [],
        productos: [],
        instalaciones: [],
      },
      modal: {
        title: "",
        accion: "",
      },
    };
  },

  validations: {
    form: {
      nombre: {
        required,
      },
      sigla: {
        required,
      },
      ciudad_id: {
        required,
      },
      bloque_id: {
        required,
      },
      dirreccion: {
        required,
      },
      latitud: {
        required,
      },
      longitud: {
        required,
      },
      horas_limite_solicitud: {
        required,
      },
      promedio_cargue: {
        required,
      },
    },
  },
  methods: {
    getIndex() {
      this.accion = this.$route.params.accion;
      if (this.$route.params.accion == "Editar") {
        this.form = this.$route.params.data_edit;
        this.metodo = "PUT";
        this.ciudad = this.form.ciudad.nombre;
        this.bloque = this.form.bloque;
        this.form.instalaciones = this.numeracionesInstalacion(
          this.form.instalaciones,
        );
      } else {
        this.metodo = "POST";
      }
    },

    getTipoSitios() {
      axios.get("/api/lista/18").then((response) => {
        this.listasForms.tipo_sitios = response.data;
      });
    },

    getActivos() {
      axios.get("/api/lista/117").then((response) => {
        this.listasForms.activos = response.data;
      });
    },

    getVentaComprado() {
      axios.get("/api/lista/173").then((response) => {
        this.listasForms.venta_comprado = response.data;
      });
    },

    getInstalaciones() {
      axios.get("/api/lista/231").then((response) => {
        this.listasForms.instalaciones = response.data;
      });
    },

    getSelectCiudades() {
      this.form.ciudad_id = this.ciudad.id;
      this.form.departamento_id = this.ciudad.departamento_id;
    },

    getCiudades() {
      axios
        .get("/api/argentina/ciudades/lista", {
          params: { pais_id: 3 },
        })
        .then((response) => {
          this.listasForms.ciudades = response.data;
        });
    },

    getSelectBloques() {
      this.form.bloque_id = this.bloque?.id ?? null;
    },

    getBloques() {
      axios
        .get("/api/argentina/bloques/lista", {
          params: { pais_id: 3 },
        })
        .then((response) => {
          this.listasForms.bloques = response.data;
        });
    },

    numeracionesInstalacion(instalaciones) {
      if (!Array.isArray(instalaciones)) {
        return [];
      }
      return instalaciones
        .map((item) =>
          item && typeof item === "object" ? item.numeracion : item,
        )
        .filter((n) => n !== null && n !== undefined && n !== "");
    },

    save() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        const payload = {
          ...this.form,
          instalaciones: this.numeracionesInstalacion(this.form.instalaciones),
        };
        axios({
          method: this.metodo,
          url: "/api/argentina/sitios",
          data: payload,
        })
          .then((response) => {
            this.cargando = false;
            this.form = response.data;
            this.form.instalaciones = this.numeracionesInstalacion(
              this.form.instalaciones,
            );
            this.accion = "Editar";
            this.metodo = "PUT";
            this.$swal({
              icon: "success",
              title: "El sitio se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    back() {
      return this.$router.replace("/Argentina/Admin/Sitios");
    },
  },

  beforeMount() {
    this.getCiudades();
    this.getBloques();
    this.getTipoSitios();
    this.getActivos();
    this.getVentaComprado();
    this.getInstalaciones();
  },

  async mounted() {
    this.getIndex();
  },
};
</script>
